import { Alert } from 'antd'
export default function Error() {
    return <div style={{
        width: '100%',
        height: '100%',
        display: 'grid',
        placeItems: 'center'
    }}>
        <Alert
            message="系统故障"
            showIcon
            description="工程师正在抢修,请稍后重试"
            type="error"
        />
    </div>
}